import g from "@babel/runtime/helpers/esm/objectSpread2";
import L from "@babel/runtime/helpers/esm/classCallCheck";
import A from "@babel/runtime/helpers/esm/createClass";
import z from "@babel/runtime/helpers/esm/assertThisInitialized";
import D from "@babel/runtime/helpers/esm/inherits";
import M from "@babel/runtime/helpers/esm/createSuper";
import m from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as R } from "@semcore/utils/lib/core/index";
import $, { sstyled as l, assignProps as s, Component as B } from "@semcore/core";
import a from "react";
import { Box as v } from "@semcore/flex-box";
import G from "@semcore/button";
import b from "@semcore/icon/Close/m";
import O from "@semcore/utils/lib/enhances/resolveColorEnhance";
import { FadeInOut as V } from "@semcore/animation";
import d from "@semcore/utils/lib/logger";
import j from "@semcore/notice-global";
import { localizedMessages as S } from "./translations/__intergalactic-dynamic-locales.mjs";
import q from "@semcore/utils/lib/enhances/i18nEnhance";
import { cssVariableEnhance as F } from "@semcore/utils/lib/useCssVariable";
import { Text as y } from "@semcore/typography";
var W = (
  /*__reshadow_css_start__*/
  (R.insert(
    /*__inner_css_start__*/
    ".___SNotice_inpr4_gg_{display:flex;padding:var(--intergalactic-spacing-4x, 16px);font-size:var(--intergalactic-fs-200, 14px);line-height:var(--intergalactic-lh-200, 142%);box-sizing:border-box;border-style:solid;border-width:1px;border-radius:var(--intergalactic-surface-rounded, 6px);color:var(--intergalactic-text-primary, #191b23)}.___SNotice_inpr4_gg_._theme_info_inpr4_gg_{background-color:var(--intergalactic-bg-secondary-info, #e9f7ff);border-color:var(--intergalactic-border-info, #8ecdff)}.___SNotice_inpr4_gg_._theme_info_inpr4_gg_ .___SCloseIcon_inpr4_gg_{color:var(--intergalactic-icon-primary-neutral, #6c6e79)}@media (hover:hover){.___SNotice_inpr4_gg_._theme_info_inpr4_gg_ .___SCloseIcon_inpr4_gg_:hover{color:var(--intergalactic-icon-primary-neutral-hover-active, #565861)}}.___SNotice_inpr4_gg_._theme_danger_inpr4_gg_{background-color:var(--intergalactic-bg-secondary-critical, #fff0f7);border-color:var(--intergalactic-border-critical, #ffaeb5)}.___SNotice_inpr4_gg_._theme_danger_inpr4_gg_ .___SCloseIcon_inpr4_gg_{color:var(--intergalactic-icon-primary-critical, #ff4953)}@media (hover:hover){.___SNotice_inpr4_gg_._theme_danger_inpr4_gg_ .___SCloseIcon_inpr4_gg_:hover{color:var(--intergalactic-icon-primary-critical-hover-active, #CC3A42)}}.___SNotice_inpr4_gg_._theme_warning_inpr4_gg_{background-color:var(--intergalactic-bg-secondary-warning, #fff3d9);border-color:var(--intergalactic-border-warning, #ffb26e)}.___SNotice_inpr4_gg_._theme_warning_inpr4_gg_ .___SCloseIcon_inpr4_gg_{color:var(--intergalactic-icon-primary-warning, #ff642d)}@media (hover:hover){.___SNotice_inpr4_gg_._theme_warning_inpr4_gg_ .___SCloseIcon_inpr4_gg_:hover{color:var(--intergalactic-icon-primary-warning-hover-active, #CC5024)}}.___SNotice_inpr4_gg_._theme_success_inpr4_gg_{background-color:var(--intergalactic-bg-secondary-success, #dbfee8);border-color:var(--intergalactic-border-success, #59ddaa)}.___SNotice_inpr4_gg_._theme_success_inpr4_gg_ .___SCloseIcon_inpr4_gg_{color:var(--intergalactic-icon-primary-success, #009f81)}@media (hover:hover){.___SNotice_inpr4_gg_._theme_success_inpr4_gg_ .___SCloseIcon_inpr4_gg_:hover{color:var(--intergalactic-icon-primary-success-hover-active, #037E68)}}.___SNotice_inpr4_gg_._theme_muted_inpr4_gg_{background-color:var(--intergalactic-bg-secondary-neutral, #f4f5f9);border-color:var(--intergalactic-border-secondary, #e0e1e9)}.___SLabel_inpr4_gg_._theme_info_inpr4_gg_,.___SNotice_inpr4_gg_._theme_muted_inpr4_gg_ .___SCloseIcon_inpr4_gg_{color:var(--intergalactic-icon-primary-neutral, #6c6e79)}@media (hover:hover){.___SNotice_inpr4_gg_._theme_muted_inpr4_gg_ .___SCloseIcon_inpr4_gg_:hover{color:var(--intergalactic-icon-primary-neutral-hover-active, #565861)}}.___SContent_inpr4_gg_{flex:1 1 auto;width:100%}.___SActions_inpr4_gg_{flex-shrink:0;margin-top:var(--intergalactic-spacing-3x, 12px)}.___SLabel_inpr4_gg_{min-height:var(--intergalactic-form-control-m, 28px);height:-moz-fit-content;height:fit-content;margin-right:var(--intergalactic-spacing-2x, 8px);display:inline-flex;align-items:center}.___SLabel_inpr4_gg_._theme_danger_inpr4_gg_{color:var(--intergalactic-icon-primary-critical, #ff4953)}.___SLabel_inpr4_gg_._theme_warning_inpr4_gg_{color:var(--intergalactic-icon-primary-warning, #ff642d)}.___SLabel_inpr4_gg_._theme_success_inpr4_gg_{color:var(--intergalactic-icon-primary-success, #009f81)}.___SLabel_inpr4_gg_._theme_muted_inpr4_gg_{color:var(--intergalactic-icon-primary-neutral, #6c6e79)}.___SLabel_inpr4_gg_._theme_custom_inpr4_gg_{color:var(--color_inpr4)}.___SCloseIcon_inpr4_gg_{flex-shrink:0;margin-left:var(--intergalactic-spacing-4x, 16px)}.___SNotice_inpr4_gg_._theme_custom_inpr4_gg_{background-color:var(--backgroundColor_inpr4);border-color:var(--backgroundColor_inpr4)}.___STitle_inpr4_gg_{margin-top:var(--intergalactic-spacing-05x, 2px);margin-bottom:var(--intergalactic-spacing-05x, 2px)}.___SText_inpr4_gg_{margin-top:var(--intergalactic-spacing-1x, 4px);margin-bottom:var(--intergalactic-spacing-1x, 4px)}",
    "inpr4_gg_"
  ), {
    __SNotice: "___SNotice_inpr4_gg_",
    __SContent: "___SContent_inpr4_gg_",
    __SActions: "___SActions_inpr4_gg_",
    __SLabel: "___SLabel_inpr4_gg_",
    _theme_info: "_theme_info_inpr4_gg_",
    _theme_danger: "_theme_danger_inpr4_gg_",
    _theme_warning: "_theme_warning_inpr4_gg_",
    _theme_success: "_theme_success_inpr4_gg_",
    _theme_muted: "_theme_muted_inpr4_gg_",
    _theme_custom: "_theme_custom_inpr4_gg_",
    "--color": "--color_inpr4",
    __SCloseIcon: "___SCloseIcon_inpr4_gg_",
    "--backgroundColor": "--backgroundColor_inpr4",
    __STitle: "___STitle_inpr4_gg_",
    __SText: "___SText_inpr4_gg_"
  })
);
function C(_) {
  return !["danger", "warning", "success", "info", "muted"].includes(_);
}
var u = /* @__PURE__ */ function(_) {
  D(r, _);
  var i = M(r);
  function r() {
    var t;
    L(this, r);
    for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++)
      n[o] = arguments[o];
    return t = i.call.apply(i, [this].concat(n)), m(z(t), "ref", /* @__PURE__ */ a.createRef()), t;
  }
  return A(r, [{
    key: "componentDidMount",
    value: function() {
      if (this.ref.current && process.env.NODE_ENV !== "production" && !["muted", "danger"].includes(this.props.theme)) {
        var e = function(o) {
          return !!(o.hasAttribute("aria-label") || o.hasAttribute("aria-labelledby") || o.hasAttribute("title"));
        };
        d.warn(!e(this.ref.current), "Provide unique 'title' or 'aria-label' or 'aria-labelledby' to help identify the type and importance of notification", this.props["data-ui-name"] || r.displayName);
      }
    }
  }, {
    key: "getLabelProps",
    value: function() {
      var e = this.asProps, n = e.theme, o = e.resolveColor;
      return {
        theme: n,
        resolveColor: o
      };
    }
  }, {
    key: "getCloseIconProps",
    value: function() {
      var e = this.asProps.getI18nText;
      return {
        getI18nText: e
      };
    }
  }, {
    key: "getCloseProps",
    value: function() {
      var e = this.asProps.getI18nText;
      return {
        getI18nText: e
      };
    }
  }, {
    key: "render",
    value: function() {
      var e = this.asProps, n, o = V, c = this.asProps, f = c.Children, x = c.styles, N = c.hidden, p = c.theme, I = c.use, T = c.resolveColor, P = c.getI18nText, k = T(p), w = C(p) ? "custom" : p;
      if (I === "primary")
        return d.warn(!0, 'Deprecated property-value pair "use=primary", use component <NoticeGlobal/> instead', r.displayName), /* @__PURE__ */ a.createElement(j, this.asProps);
      var h = P(p === "danger" ? "criticalNotification" : "notification");
      p === "muted" && (h = void 0);
      var E = p === "muted" ? void 0 : "region";
      return n = l(x), /* @__PURE__ */ a.createElement(o, n.cn("SNotice", g({}, s({
        visible: !N,
        "use:theme": w,
        backgroundColor: k,
        role: E,
        "aria-label": h,
        ref: this.ref
      }, e))), /* @__PURE__ */ a.createElement(f, n.cn("Children", {})));
    }
  }]), r;
}(B);
m(u, "displayName", "Notice");
m(u, "style", W);
m(u, "enhance", [q(S), F({
  variable: "--intergalactic-duration-popper",
  fallback: "200",
  map: Number.parseInt,
  prop: "duration"
}), O()]);
m(u, "defaultProps", {
  theme: "info",
  i18n: S,
  locale: "en"
});
function H(_) {
  var i = arguments[0], r, t = _.styles, e = _.theme, n = _.resolveColor, o = v, c = C(e) ? "custom" : e, f = n(e);
  return r = l(t), /* @__PURE__ */ a.createElement(o, r.cn("SLabel", g({}, s({
    "use:theme": c,
    color: f
  }, i))));
}
function J(_) {
  var i = arguments[0], r, t = _.styles, e = y;
  return r = l(t), /* @__PURE__ */ a.createElement(e, r.cn("STitle", g({}, s({
    tag: "div",
    size: 300,
    fontWeight: "bold"
  }, i))));
}
function K(_) {
  var i = arguments[0], r, t = _.styles, e = y;
  return r = l(t), /* @__PURE__ */ a.createElement(e, r.cn("SText", g({}, s({
    tag: "div"
  }, i))));
}
function Q(_) {
  var i = arguments[0], r, t = _.styles, e = v;
  return r = l(t), /* @__PURE__ */ a.createElement(e, r.cn("SActions", g({}, s({}, i))));
}
function U(_) {
  var i = arguments[0], r, t = _.styles, e = v;
  return r = l(t), /* @__PURE__ */ a.createElement(e, r.cn("SContent", g({}, s({}, i))));
}
function X(_) {
  var i = arguments[0], r, t = _.styles, e = _.getI18nText, n = v;
  return r = l(t), /* @__PURE__ */ a.createElement(n, r.cn("SCloseIcon", g({}, s({
    tag: b,
    interactive: !0,
    "aria-label": e("close")
  }, i))));
}
function Y(_) {
  var i = arguments[0], r, t = _.styles, e = _.getI18nText, n = G;
  return r = l(t), /* @__PURE__ */ a.createElement(n, r.cn("SCloseIcon", g({}, s({
    addonLeft: b,
    use: "tertiary",
    theme: "muted",
    "aria-label": e("close")
  }, i))));
}
var Se = $(u, {
  Label: H,
  Title: J,
  Text: K,
  Actions: Q,
  Content: U,
  CloseIcon: X,
  Close: Y
});
export {
  Se as default
};
